<template>
  <div class="d-flex flex-column align-center decision-card-wrapper">
    <v-card class="rounded-0 elevation-0 flatter" width="100%" :maxWidth="computedMaxCardWidth" :class="{'deleting': deleting}" :outlined="!option.shortListed">
      <v-img
        :eager="true"
        :src="optionImgSrc"
        class="white--text"
        contain
        :class="imgUrl ? 'align-end' : 'align-center'"
        :gradient="imgUrl ? undefined : 'to bottom, rgba(0,0,0,.5), rgba(0,0,0,.9)'"
        :height="cardHeight"
        :min-width="minCardWidth"
      >
      </v-img>

      <v-card-title class="text-h5 font-weight-bold text-left">
          {{ option.name }}
      </v-card-title>
      <!-- <v-card-actions>
        <v-btn small color="primary">
          <v-icon small class="mr-2">mdi-heart</v-icon> Consider
        </v-btn>
      </v-card-actions> -->

      <!-- <v-expand-transition> -->
        <div v-if="criteria && criteria.length > 0">
          <v-container fluid class="py-0">
            <v-row>
              <v-col cols="12" md="3" class="d-flex justify-start mt-3 pb-0">
                <h4>Specifications</h4>
              </v-col>
              <v-col cols="12" md="9">
                <div v-for="criteriaItem in criteria" :key="criteriaItem.id">
                  <v-row>
                    <v-col cols="12" align="start" class="pb-0">
                      <div class="mr-1 info--text font-weight-bold">{{criteriaItem.name}}:</div>
                      <CriteriaValue v-if="option.criteriaValues" :keywordOnly="criteriaItem.keywordOnly" :valueExpired="outOfDateCriteria[criteriaItem.id]" :value="option.criteriaValues[criteriaItem.id]" :range="criteriaItem.range" />
                    </v-col>
                  </v-row>
                </div>
              </v-col>
            </v-row>
            <v-row v-if="pros.length > 0">
              <v-col cols="12" md="3" class="d-flex justify-start pb-0">
                <h4>Reasons for</h4>
              </v-col>
              <v-col cols="12" md="9">
                <v-row v-for="pro in pros" :key="pro.id">
                  <span class="pros-marker">+</span>
                  {{pro.reasonText}}
                </v-row>
              </v-col>
            </v-row>
            <v-row v-if="cons.length > 0">
              <v-col cols="12" md="3" class="d-flex justify-start pb-0">
                <h4>Reasons against</h4>
              </v-col>
              <v-col cols="12" md="9">
                <v-row v-for="con in cons" :key="con.id">
                  <span class="cons-marker">-</span>
                  {{con.reasonText}}
                </v-row>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12" md="3" class="d-flex justify-start pb-0">
                <h4>Where to find it</h4>
              </v-col>
              <v-col cols="12" md="9">
                <v-row class="d-flex align-center justify-space-between mb-4">
                  <v-btn v-if="option.url"
                    text
                    dark
                    x-small
                    target="_blank"
                    :href="option.url"
                  >
                    <span v-if="hostname" class="accent--text">{{hostname}}</span><v-icon class="ml-1" color="accent" x-small>mdi-open-in-new</v-icon>
                  </v-btn>
                  <!-- <v-btn class="ml-2" outlined small color="success">
                    <div class="d-flex flex-column align-center">
                      <div>
                        <v-icon x-small class="mr-2">mdi-cart</v-icon> Buy Now
                      </div>
                      <div style="font-size: 0.4rem">
                        from {{hostname}}
                      </div>
                    </div>
                  </v-btn> -->
                </v-row>
                <!-- <v-row class="d-flex align-center mb-4">
                  <v-btn v-if="option.url"
                    text
                    dark
                    x-small
                    target="_blank"
                    :href="option.url"
                  >
                    <span class="accent--text">www.jbhifi.co.nz</span><v-icon class="ml-1" color="accent" x-small>mdi-open-in-new</v-icon>
                  </v-btn>
                </v-row>
                <v-row class="d-flex align-center mb-4">
                  <v-btn v-if="option.url"
                    text
                    dark
                    x-small
                    target="_blank"
                    :href="option.url"
                  >
                    <span class="accent--text">www.noelleeming.co.nz</span><v-icon class="ml-1" color="accent" x-small>mdi-open-in-new</v-icon>
                  </v-btn>
                </v-row>
                <v-row class="d-flex align-center mb-4">
                  <v-btn v-if="option.url"
                    text
                    dark
                    x-small
                    target="_blank"
                    :href="option.url"
                  >
                    <span class="accent--text">pbtech.co.nz</span><v-icon class="ml-1" color="accent" x-small>mdi-open-in-new</v-icon>
                  </v-btn>
                </v-row> -->
              </v-col>
            </v-row>

          </v-container>
          <!-- <v-divider></v-divider>
          <v-card-actions>
            <v-btn
              text
              rounded
              small
              @click="showCriteriaValues = false"
            >
              Hide Values
            </v-btn>
          </v-card-actions> -->
        </div>
      <!-- </v-expand-transition> -->
      <!-- <v-expand-transition>
        <div v-if="showProsCons">
          <v-divider></v-divider>
          <v-card flat>
          <v-container fluid>
            <v-row>
              <v-col>
                <div class="d-flex align-center justify-space-between text-subtitle-1 text-center">
                  <div>
                    <strong v-if="pros.length > 0">{{ pros.length }}</strong> Pros
                  </div>
                </div>
                <div>
                  <v-chip class="ma-2"
                    color="success"
                    text-color="white"
                    v-for="pro in pros"
                    :key="pro.id"
                  >
                    <UserAvatar
                      class="mr-2"
                      :email="pro.ownerName"
                      :size="24"
                      color="green darken-4"
                    />
                      {{ pro.reasonText }}
                  </v-chip>
                </div>
              </v-col>
              <v-divider vertical />
              <v-col>
                <div class="d-flex align-center justify-space-between text-subtitle-1 text-center">
                  <div>
                    <strong v-if="cons.length > 0">{{ cons.length }}</strong> Cons
                  </div>
                </div>
                <div>
                  <v-chip class="ma-2"
                    color="error"
                    text-color="white"
                    v-for="con in cons"
                    :key="con.id"
                  >
                    <UserAvatar
                      class="mr-2"
                      :email="con.ownerName"
                      :size="24"
                      color="red darken-4"
                    />
                      {{ con.reasonText }}
                  </v-chip>
                </div>
              </v-col>
            </v-row>
          </v-container>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              text
              rounded
              small
              @click="showProsCons = false"
            >
              Hide Pros and Cons
            </v-btn>
          </v-card-actions>
        </v-card>
        </div>
      </v-expand-transition> -->
    </v-card>
  </div>
</template>

<script>
import Constants from '../constants.json'
// This import loads the firebase namespace along with all its type information.
import * as firebase from 'firebase/app'
// Load the auth feature into the firebase namespace.
import 'firebase/auth'
import axios from 'axios'

import { mapGetters } from 'vuex'

import CriteriaValue from '@/components/CriteriaValue.vue'
import guid from '@/mixins/DecidedlyGUID.js'
// import UserAvatar from '@/components/UserAvatar.vue'

export default {
  name: 'DecidedOptionCard',
  mixins: [guid],
  components: {
    CriteriaValue,
    // UserAvatar
  },
  props: {
    option: Object,
    imgUrl: String,
    // criteria: Array,
    maxCardWidth: {
      type: Number,
      default: 350
    },
    cardHeight: {
      type: Number,
      default: 200
    },
    minCardWidth: {
      type: Number,
      default: 248
    },
    isNewOption: {
      type: Boolean,
      default: false
    },
    isChosenOption: {
      type: Boolean,
      default: false
    },
    isComparable: {
      type: Boolean,
      default: true
    },
    inCompareList: {
      type: Boolean,
      default: false
    },
    isEditable: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      showProsCons: false,
      showCriteriaValues: false,
      editingCriteria: false,
      editingValues: null,
      deleting: false,
      checkingContent: false,
      confirmDeleteDialog: false,
      optionReasons: [],
      urlStates: {
        unknown: {name: 'Link status unknown', icon: 'mdi-link-off', color: 'info'},
        broken: {name: 'Broken Link. The page for this option is no longer available', icon: 'mdi-link-off', color: 'error'},
        latest: {name: 'This option is up to date', icon: 'mdi-clock-check-outline', color: 'success'},
        stale: {name: 'The page has changed and your values could be out of date. Click to refresh and check the values are up to date', icon: 'mdi-refresh', color: 'warning'},
        changed: {name: 'The values selected from this page are out of date. Click to fetch the latest content for this option and choose new values', icon: 'mdi-swap-horizontal', color: 'warning'}
      },
      lastScrapeStatus: null,
      checkingValues: false,
      //outOfDateCriteria: {},
      updatingSha256: false,
      checkedValuesScrapeResult: null,
      checkRescrapFinishedInterval: null,
      rebuilding: false,
      booleanCriteriaValueOptions: ['YES', 'NO']
    }
  },
  computed: {
    ...mapGetters('decision',{
      criteria: 'criteriaList'
    }),
    computedMaxCardWidth () {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs': return '100%'
        case 'sm': return '100%'
        default: return this.maxCardWidth
      }
    },
    currentUserID () {
      return firebase.auth().currentUser.uid
    },
    optionImgSrc () {
      let res = this.imgUrl
      if (!res) {
        res = `${Constants.SCREENSHOT_CDN}/unknownimage.png`
      }
      // if (res.indexOf('https:') !== 0) {
      //    res = `${Constants.SCREENSHOT_CDN}/notsecureimage.png`
      // }
      return res
    },
    outOfDateCriteria () {
      let res = {}

      this.criteria.forEach((nextCriterion) => {
        let newValues = []
        if (this.checkedValuesScrapeResult) {
          newValues = this.checkedValuesScrapeResult.newValues[nextCriterion.id] || null
        }
        // Set the value to the first in the list
        if (newValues && newValues.length > 0) {
          if (this.option.criteriaValues[nextCriterion.id]) {
            const sourceVal = this.option.criteriaValues[nextCriterion.id].sourceValue
            const foundValue = newValues.find((nextItem) => {
              return nextItem.value === sourceVal
            })
            if (!foundValue) {
              res[nextCriterion.id] = true
            }
          }
        }
      })

      return res
    },
    hostname () {
      if (this.option.url) {
        return new URL(this.option.url).hostname
      } else {
        return null
      }
    },
    urlStatus () {
      let res = this.lastScrapeStatus || this.urlStates.latest
      // Check if the status is changed, but there are no out of date criteria, in this case we want to set the status to latest
      if (res === this.urlStates.changed && (Object.keys(this.outOfDateCriteria).length === 0 && this.outOfDateCriteria.constructor === Object)) {
        res = this.urlStates.latest
      }

      return res
    },
    valueSyncIcons () {
      const valueIconsMap = {}
      this.criteria.forEach((item) => {
        let iconStr = 'mdi-clock-check-outline'
        let iconColor = 'success'
        let tooltipText  = `This value is up to date and was provided by ${this.hostname}`
        let valueStatus = this.urlStates.latest
        if (this.option.scrapeState === Constants.SCRAPE_STATES.scraped) {
          iconStr = 'mdi-help'
          iconColor = 'info'
          tooltipText = `This value has not been approved yet`
        }
        else if (this.urlStatus === this.urlStates.stale) {
          iconStr = 'mdi-help'
          iconColor = 'info'
          tooltipText = `This value might be out of date as the content on ${this.hostname} has changed`
          valueStatus = this.urlStates.stale
        }
        else if (this.urlStatus === this.urlStates.broken) {
          iconStr = 'mdi-help'
          iconColor = 'info'
          tooltipText = `This value might be out of date as the link to ${this.hostname} is not currently available`
          valueStatus = this.urlStates.stale
        }
        else if (this.outOfDateCriteria[item.id]) {
          iconStr = 'mdi-swap-horizontal'
          iconColor = 'warning'
          tooltipText = `This value has change on ${this.hostname}`
          valueStatus = this.urlStates.changed
        }
        valueIconsMap[item.id] = { icon: iconStr, color: iconColor, tooltip: tooltipText, status: valueStatus}
      })
      return valueIconsMap
    },
    reasonColor () {
      let colorValue = 'info'
      if (this.optionReasons.length > 0) {
        if (this.pros.length > this.cons.length) {
          colorValue = 'success'
        } else if (this.pros.length < this.cons.length) {
          colorValue = 'error'
        }
      }
      return colorValue
    },
    pros () {
      return this.optionReasons.filter(reason => reason.isContra === false)
    },
    cons () {
      return this.optionReasons.filter(reason => reason.isContra === true)
    }
  },
  mounted: function () {
    // console.log(`Showing decided card with criteria ${JSON.stringify(this.criteria)}`)
    this.loadOptionReasons()
  },
  methods: {
    handleToggleCompareAction: function () {
      this.$emit('onCompare')
    },
    loadOptionReasons: async function () {
      this.optionReasons = []
      const token = firebase.auth().currentUser && (await firebase.auth().currentUser.getIdToken())
      const reasonsURL = `${Constants.API_BASE_PATH}/decisions/${this.option.decisionId}/options/${this.option.id}/reasons`
      const res = await axios.get(reasonsURL, {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`,
        }
      });
      if (res.status === 200) {
        // console.log(`GOT reasons response ${JSON.stringify(res.data)}`)
        this.optionReasons = res.data
        // Also set it for the option
        this.option.optionReasons = this.optionReasons
      }
    },
    openURL: function (url) {
      window.open(url, '_blank');
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.decision-card-wrapper {
  width: 100%;
  margin-top: 40px;
  margin-bottom: 40px;
}
.flatter {

}
.deleting {
  opacity: 0.2;
}
.elevation-8 .v-card__title {
  font-size: 1rem;
  position: relative;
  // background-color: rgba(0,0,0,0.6);
  border-top: 1px solid #CCC;
  border-bottom: 1px solid #CCC;
  padding: 5px 16px;
}
.elevation-0 .v-card__title {
  font-size: 1rem;
  position: relative;
  // background-color: rgba(0,0,0,0.6);
  border-top: 1px solid #CCC;
  border-bottom: 1px solid #CCC;
  padding: 5px 16px;
}
.elevation-0 .v-card__actions {
  border-bottom: 1px solid #CCC;
}
.top-actions {
  display: flex;
  justify-content: space-between;
  align-items: center;

  .non-breaking-space {
    width: 28px;
  }

  .compare-active {
    background-color: #4caf50;
    color: #FFF;

    &:hover {
      background-color: rgba(76, 175, 80, 0.3);
      color: #607d8b;
    }
  }
}
.delete-action:hover {
  color: #FFF;
  background-color: rgba(244, 67, 54, 0.7);
}
.user-name-caption {
  font-size: 0.65rem;
  position: absolute;
  top: -1px;
}
.pros-marker {
  font-weight: 600;
  margin-right: 10px;
}
.cons-marker {
  font-weight: 600;
  margin-right: 10px;
}
</style>
<style lang="scss">
.editing-value-field.with-value .v-label {
  color: #4caf50;
  opacity: 1;
}
.editing-value-field.no-value .v-label {
  color: #f44336;
  opacity: 1;
}
.d-option-card-name {

  .edit-card-name {
    display: none;
  }

  &:hover {
    .edit-card-name {
      display: block;
    }
  }
}
.pros-cons-section {
  border-top: 1px solid #CCC;
  background: #EEE;
  width: 100%;
}
</style>
